import { useEffect } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAsync,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpClientResponse,
} from '@services/httpClientService';
import { nonAwaitedPromiseHandlerParametrized } from '@utils/async';

import { ICartContent } from '../../../model';
import { transformCartBenefits } from '../../mapper';

import { CART_CONTENT_QUERY } from './cartContentQuery';
import { ICartContentResponse } from './model';

const mappingFunction = (result: ICartContentResponse): IGeneralRequestResponse<ICartContent> => {
  const { benefits } = result.cartContent.data;
  return {
    ...result.cartContent,
    data: {
      ...result.cartContent.data,
      benefits: transformCartBenefits(benefits),
    },
  };
};

export const useGetCartContentOnRender = (): IHttpClientResponse<
  IGeneralRequestResponse<ICartContent>,
  IGraphQlQuery
> => {
  const asyncRequest = useHttpClientAsync<IGeneralRequestResponse<ICartContent>, IGraphQlQuery, ICartContentResponse>({
    method: httpMethods.POST,
    path: ApiSectionNamespace.ECartPageApiKeys.CART_PAGE_CONTENT_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  useEffect(() => {
    nonAwaitedPromiseHandlerParametrized(asyncRequest.request, { data: { query: CART_CONTENT_QUERY } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return asyncRequest;
};
